const blankRoutes = [
    {
        path: 'email-template-builder',
        name: 'email-template-builder',
        component: () => import('../views/clientAdmin/EmailTemplateBuilderView.vue'),
        meta: {
            title: 'Banner Insite - Email Template Builder',
            permissions: ["system_admin", "client_admin", "admin", "manager", "user"]
        },
        sensitive: true,
        strict: true
    },

    // {
    //     path: 'interface',
    //     name: 'interface',
    //     component: () => import('../views/systemAdmin/Interface.vue'),
    //     meta: {
    //         title: 'Banner Insite - Interface',
    //         permissions: ['system_admin']
    //     },
    //     sensitive: true,
    //     strict: true
    // }
    
]

export default blankRoutes